import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { CurrentUser } from '../interfaces/user';
import { TitleService } from '../../core/services/title.service';
import { ProfileService } from '../services/profile.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProfileTitleResolver implements Resolve<CurrentUser | null> {
  constructor(private title: TitleService, private profileService: ProfileService) {}
  resolve(): Promise<CurrentUser | null> {
    const t = 'Profile';
    this.title.setTitle(t);
    return firstValueFrom(this.profileService.load());
  }
}
